module.exports = __webpack_public_path__ + "img/meslo.8fe3b43a.svg";